import { useCommonUseOfFundsListSuspense } from "@boundless/bl-api-client/common/services"

import { FormInputNumeric } from "@/components/form-elements/FormInputNumeric"
import { FormSection } from "@/components/form-elements/FormSection"
import { FormSelect } from "@/components/form-elements/FormSelect"
import { sortByLabel } from "@/lib/utils"

type FundingNeedsFormProps = {
  disabled?: boolean
}

export function FundingNeedsForm({ disabled = false }: FundingNeedsFormProps) {
  const { data: useOfFundsData } = useCommonUseOfFundsListSuspense()

  const useOfFundsOptions = sortByLabel(
    useOfFundsData.map((item) => ({
      label: item.name,
      id: item.id,
    })),
  )
  return (
    <div className="@container/form">
      <FormSection>
        <FormInputNumeric
          name="capitalAmount"
          label="Capital Amount"
          placeholder="Capital Amount"
          disabled={disabled}
        />
        <FormSelect
          name="useOfFunds"
          label="Use of Funds"
          placeholder="Use of Funds"
          options={useOfFundsOptions}
          parseValueAsInt
          disabled={disabled}
        />
      </FormSection>
    </div>
  )
}
